import { useState } from 'react';
import { Group, Text, UnstyledButton } from '@mantine/core';
import { TbCalculator, TbCheck, TbChevronDown } from 'react-icons/tb';
import FormPFDeadlineCalculator from '../components/CreateProject/components/FormPFDeadlineCalculator';
import { TypeCards } from './style';

// Shared by the new-project and new-period drawers, so Form PF reads the same in both.

// A few choices, each with its line of explanation, as the report cards above and the classic form show them.
export const OptionCards = ({ options, value, onChange }) => (
  <TypeCards>
    {options.map(option => (
      <UnstyledButton
        key={option.value}
        data-active={option.value === value}
        aria-pressed={option.value === value}
        onClick={() => onChange(option.value)}
      >
        <span className="title">{option.label}</span>
        <span className="description">{option.description}</span>
      </UnstyledButton>
    ))}
  </TypeCards>
);

// Each filing type says when it applies, as the classic form's tooltips did; the check replaces Mantine's own.
export const describedOption = ({ option, checked }) => (
  <Group gap={8} wrap="nowrap" align="flex-start" w="100%">
    <div style={{ flex: 1 }}>
      <Text size="13px">{option.label}</Text>
      <Text size="xs" c="dimmed">
        {option.description}
      </Text>
    </div>
    {checked && <TbCheck size={14} style={{ flex: 'none', marginTop: 3 }} />}
  </Group>
);

// In sight, as the classic form's accordion was; a small underlined link went unnoticed. Styled by FormPFBlock.
export const DeadlineCalculator = () => {
  const [isOpen, setOpen] = useState(false);
  return (
    <div className="calculator" data-open={isOpen}>
      <UnstyledButton
        className="calculatorHead"
        type="button"
        aria-expanded={isOpen}
        onClick={() => setOpen(open => !open)}
      >
        <span className="tile">
          <TbCalculator size={16} />
        </span>
        <span className="copy">
          <span className="title">Form PF deadline calculator</span>
          <span className="description">Not sure which filing type? Check your due dates</span>
        </span>
        <TbChevronDown size={14} className="chevron" />
      </UnstyledButton>

      {/* The block's styles bring its type down to this form's size and hide its table until it has rows. */}
      {isOpen && (
        <div className="calculatorBody">
          <FormPFDeadlineCalculator bare />
        </div>
      )}
    </div>
  );
};
